"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { INotificationDropReplied } from "@/types/feed.types";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import Drop, { DropInteractionParams, DropLocation } from "@/components/waves/drops/Drop";
import { DropSize, ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter } from "next/navigation";
import { ApiDrop } from "@/generated/models/ApiDrop";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
export default function NotificationDropReplied(t0) {
  const $ = _c(47);
  const {
    notification,
    activeDrop,
    onReply,
    onQuote,
    onDropContentClick
  } = t0;
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  const baseWave = notification.related_drops[1].wave as any;
  const isDirectMessage = baseWave?.chat?.scope?.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== isApp || $[1] !== isDirectMessage || $[2] !== notification.related_drops[1].wave.id || $[3] !== router) {
    t1 = serialNo => {
      router.push(getWaveRoute({
        waveId: notification.related_drops[1].wave.id,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[0] = isApp;
    $[1] = isDirectMessage;
    $[2] = notification.related_drops[1].wave.id;
    $[3] = router;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onReplyClick = t1;
  let t2;
  if ($[5] !== isApp || $[6] !== isDirectMessage || $[7] !== router) {
    t2 = quote => {
      const quoteWave = quote.wave as any;
      const quoteIsDm = quoteWave?.chat?.scope?.group?.is_direct_message ?? isDirectMessage;
      router.push(getWaveRoute({
        waveId: quote.wave.id,
        serialNo: quote.serial_no,
        isDirectMessage: quoteIsDm,
        isApp
      }));
    };
    $[5] = isApp;
    $[6] = isDirectMessage;
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onQuoteClick = t2;
  let t3;
  if ($[9] !== notification.related_drops[1].author.pfp) {
    t3 = <div className="tw-h-7 tw-w-7">{notification.related_drops[1].author.pfp ? <img src={getScaledImageUri(notification.related_drops[1].author.pfp, ImageScale.W_AUTO_H_50)} alt="#" className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[9] = notification.related_drops[1].author.pfp;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = notification.related_drops[1].author.handle ?? "";
  const t5 = `/${notification.related_drops[1].author.handle}`;
  let t6;
  if ($[11] !== notification.related_drops[1].author.handle || $[12] !== t5) {
    t6 = <Link href={t5} className="tw-no-underline tw-font-semibold tw-text-sm tw-text-iron-50">{notification.related_drops[1].author.handle}</Link>;
    $[11] = notification.related_drops[1].author.handle;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <UserProfileTooltipWrapper user={t4}>{t6}</UserProfileTooltipWrapper>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-text-iron-400 tw-font-normal tw-text-sm">replied</span>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="tw-font-bold tw-mr-1 tw-text-iron-400">•</span>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== notification.created_at) {
    t10 = getTimeAgoShort(notification.created_at);
    $[19] = notification.created_at;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t9}{" "}{t10}</span>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t7) {
    t12 = <span className="tw-inline-flex tw-flex-wrap tw-gap-x-1 tw-items-center">{t7}{" "}{t8}{" "}{t11}</span>;
    $[23] = t11;
    $[24] = t7;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t3) {
    t13 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t3}{t12}</div>;
    $[26] = t12;
    $[27] = t3;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== notification.related_drops[1].author) {
    t14 = <NotificationsFollowBtn profile={notification.related_drops[1].author} size={UserFollowBtnSize.SMALL} />;
    $[29] = notification.related_drops[1].author;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <div className="tw-flex tw-justify-between tw-gap-x-4 tw-gap-y-1">{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== notification.related_drops[1]) {
    t16 = {
      type: DropSize.FULL,
      ...notification.related_drops[1],
      stableKey: "",
      stableHash: ""
    };
    $[34] = notification.related_drops[1];
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== activeDrop || $[37] !== onDropContentClick || $[38] !== onQuote || $[39] !== onQuoteClick || $[40] !== onReply || $[41] !== onReplyClick || $[42] !== t16) {
    t17 = <Drop drop={t16} previousDrop={null} nextDrop={null} showWaveInfo={true} showReplyAndQuote={true} activeDrop={activeDrop} location={DropLocation.MY_STREAM} dropViewDropId={null} onReply={onReply} onQuote={onQuote} onReplyClick={onReplyClick} onQuoteClick={onQuoteClick} onDropContentClick={onDropContentClick} />;
    $[36] = activeDrop;
    $[37] = onDropContentClick;
    $[38] = onQuote;
    $[39] = onQuoteClick;
    $[40] = onReply;
    $[41] = onReplyClick;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t15 || $[45] !== t17) {
    t18 = <div className="tw-w-full tw-flex tw-gap-x-3"><div className="tw-w-full tw-flex tw-flex-col tw-space-y-2">{t15}{t17}</div></div>;
    $[44] = t15;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  return t18;
}